import type { ReactElement } from 'react';
import { getFontFamily } from '@/theme/typography';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface MindmapCompactPreviewChildRowProps {
    dataElScope: DataElScope;
    isLast: boolean;
    label: string;
}
export function MindmapCompactPreviewChildRow({ dataElScope, isLast, label, }: MindmapCompactPreviewChildRowProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'MindmapCompactPreviewChildRow/Entry')} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontFamily: getFontFamily(),
            fontSize: 11,
            color: 'rgba(255,255,255,0.76)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        }}>
        <span style={{
            width: 16,
            flexShrink: 0,
            color: 'rgba(147,216,255,0.6)',
            textAlign: 'left',
        }}>
          {isLast ? '└─' : '├─'}
        </span>
        <span style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }}>
          {label}
        </span>
      </div>
    );
}
